import { useNavigate } from 'react-router-dom';
import IconEdit from '../../../../../components/icons/icon-edit/icon-edit';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';
import { PLAN_TYPES } from '../../../../../models/Plan';

interface EditPlanButtonProps {
    children?: React.ReactNode;
    planId: number;
    type: PLAN_TYPES;
}

const EditPlanButton: React.FC<EditPlanButtonProps> = ({ planId, type }) => {
    let navigate = useNavigate();
    const handleClick = () => {
        navigate({
            pathname: `${type}/${planId.toString()}`,
        });
    }
    return (
        <ButtonIcon Component={IconEdit} onClick={handleClick} />
    );
};

export default EditPlanButton;
